// src/icons/GraphQLTwoTone.tsx
import { jsx, jsxs } from "@emotion/react/jsx-runtime";
function GraphQLTwoTone() {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "100%",
      viewBox: "0 0 22 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M1.58766 17.6612L2.4502 18.1592L12.0591 1.51639L11.1966 1.01839L1.58766 17.6612Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M20.6095 16.3309H1.3916V17.3269H20.6095V16.3309Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M1.76929 16.8913L11.3818 22.4413L11.8798 21.5787L2.26729 16.0288L1.76929 16.8913Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M10.1199 2.42546L19.7324 7.97546L20.2304 7.11293L10.6179 1.56293L10.1199 2.42546Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M1.77056 7.10902L2.26855 7.97156L11.8811 2.42156L11.3831 1.55902L1.77056 7.10902Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M9.94574 1.51639L19.5547 18.1592L20.4172 17.6612L10.8083 1.01839L9.94574 1.51639Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M3.14834 6.45007H2.15234V17.5501H3.14834V6.45007Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M19.8515 6.45007H18.8555V17.5501H19.8515V6.45007Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M10.7779 21.266L11.2129 22.0194L19.5732 17.1924L19.1382 16.439L10.7779 21.266Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M21.1713 17.874C20.5953 18.876 19.3113 19.218 18.3093 18.642C17.3073 18.066 16.9653 16.782 17.5413 15.78C18.1173 14.778 19.4013 14.436 20.4033 15.012C21.4113 15.594 21.7533 16.872 21.1713 17.874Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M4.45548 8.21973C3.87948 9.22173 2.59549 9.56373 1.5935 8.98773C0.591502 8.41173 0.249504 7.12773 0.825501 6.12573C1.4015 5.12373 2.68549 4.78173 3.68748 5.35773C4.68948 5.93973 5.03148 7.21773 4.45548 8.21973Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M0.83136 17.874C0.255364 16.872 0.597361 15.594 1.59936 15.012C2.60135 14.436 3.87934 14.778 4.46134 15.78C5.03734 16.782 4.69534 18.06 3.69334 18.642C2.68535 19.218 1.40736 18.876 0.83136 17.874Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M17.5472 8.21973C16.9712 7.21773 17.3132 5.93973 18.3152 5.35773C19.3172 4.78173 20.5952 5.12373 21.1772 6.12573C21.7532 7.12773 21.4112 8.40573 20.4092 8.98773C19.4072 9.56373 18.1232 9.22173 17.5472 8.21973Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M11.0002 23.7477C9.84224 23.7477 8.90625 22.8117 8.90625 21.6537C8.90625 20.4957 9.84224 19.5597 11.0002 19.5597C12.1582 19.5597 13.0942 20.4957 13.0942 21.6537C13.0942 22.8057 12.1582 23.7477 11.0002 23.7477Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M11.0002 4.43983C9.84224 4.43983 8.90625 3.50383 8.90625 2.34583C8.90625 1.18783 9.84224 0.251831 11.0002 0.251831C12.1582 0.251831 13.0942 1.18783 13.0942 2.34583C13.0942 3.50383 12.1582 4.43983 11.0002 4.43983Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}

export {
  GraphQLTwoTone
};
